// extracted by mini-css-extract-plugin
module.exports = {"question":"style_question__9fNyK","invalidValue":"style_invalidValue__1t2-m"};